module.exports = __webpack_public_path__ + "img/bg-02.5619614e.jpg";